<template>
  <div class="page-container">
    <div class="hero-banner">
      <div class="overlay"></div>
      <div class="hero-content container">
        <h1 class="display-4 font-weight-bold">Community Space</h1>
        <p class="lead">Connect, share, and grow with your colleagues.</p>
      </div>
      <div class="wave-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#f8f9fc" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,224C672,245,768,267,864,250.7C960,235,1056,181,1152,165.3C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </div>

    <div class="container main-content">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
          <add-post />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AddPost from '@/components/AddPost.vue';


export default {
    components:{
         AddPost
    },
    name:"PostView",
}

</script>



 <style lang="scss" scoped>
 
$primary-gradient: linear-gradient(135deg, #4e73df 0%, #224abe 100%);
$soft-bg: #f8f9fc;

.page-container {
  background-color: $soft-bg;
  min-height: 100vh;
}

.hero-banner {
  position: relative;
  height: 350px;
  background: $primary-gradient;
  display: flex;
  align-items: center;
  color: white;
  overflow: hidden;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('https://www.transparenttextures.com/patterns/cubes.png'); 
    opacity: 0.1;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    text-align: left;
    
    h1 {
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      letter-spacing: -1px;
    }
    
    p {
      opacity: 0.9;
      font-weight: 300;
    }
  }

  .wave-container {
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    line-height: 0;
  }
}

.main-content {
  margin-top: -80px;  
  position: relative;
  z-index: 5;
  padding-bottom: 50px;
}
 
@media (max-width: 768px) {
  .hero-banner {
    height: 250px;
    text-align: center;
    .hero-content {
      text-align: center;
      h1 { font-size: 2rem; }
    }
  }
  .main-content {
    margin-top: -40px;
  }
}
</style>